


export class CN45N {
  "order";
  "description";
  "status";
  "companyCode";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CN45N`.
   */
  static getModelName() {
    return "CN45N";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CN45N for dynamic purposes.
  **/
  static factory(data) {
    return new CN45N(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'CN45N',
      plural: 'CN45Ns',
      path: 'CN45Ns',
      properties: {
        "order": {
          name: 'order',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/CN45N.js